import React from "react";

import "./underMaintenance.css";

import Lottie from "react-lottie";
import animation from "../../assets/lottie/players.json";

const UnderMaintenance = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="underMaintenance">
      <div className="underMaintenance-wrapper">
        <div className="underMaintenance-content-wrapper">
          <div className="underMaintenance-contentTop-wrapper">
            <Lottie options={defaultOptions} height={300} width={300} />
          </div>
          <div className="underMaintenance-contentBottom-wrapper">
            <h2>Back in a Moment</h2>
            <p>We’re making a quick update.</p>
      <p>Don't move, we are coming right back!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderMaintenance;
